const unidecode = require('unidecode');

module.exports = {
  capitalize: (string) => {
    return string[0].toUpperCase() + string.slice(1);
  },

  formatTime: (time) => {
    if (time === null) {
      return "00:00";
    }
    return time.slice(0, 5);
  },

  sortItems: (items, sortBy) => {
    function compare(a, b) {
      const desc = sortDir === "desc";
      let result = 0;
      if (a[sortField] && b[sortField]) {
        if (a[sortField] > b[sortField]) {
          result = desc ? -1 : 1;
        } else if (a[sortField] < b[sortField]) {
          result = desc ? 1 : -1;
        }
      } else if (a[sortField]) {
        result = desc ? -1 : 1;
      } else if (b[sortField]) {
        result = desc ? 1 : -1;
      }
      return result;
    }
    const [sortField, sortDir] = sortBy.split("|");
    let sortedItems = [...items];
    sortedItems.sort(compare);
    return sortedItems;
  },

  groupItems: (items, groupBy, sortDir = null) => {
    // function sortObj(obj) {
    //   return Object.keys(obj)
    //     .sort()
    //     .reverse()
    //     .reduce(function (result, key) {
    //       result[key] = obj[key];
    //       return result;
    //     }, {});
    // }
    const groupedItems = items.reduce((result, item) => {
      let key = item[groupBy];
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(item);
      return result;
    }, {});
    return groupedItems;
  },

  getAuthorsComponentsFromText: (authorsText) => {
    let aaTexts = [];
    if (authorsText.includes(";")) {
        aaTexts = authorsText.split(/;| and | y /).map(a => a.trim());
    } else if (authorsText.includes(",")) {
        aaTexts = authorsText.split(/,| and | y /).map(a => a.trim());
    } else {
        aaTexts = [authorsText.trim()];
    }

    let aaComponents = aaTexts.map(a => unidecode(a.toLowerCase()).split(/\.|-| /));
    aaComponents = aaComponents.map(cs => cs.filter(c => c));
    aaComponents = aaComponents.filter(cs => cs.length > 0);

    return [ aaComponents, aaTexts ];
  },

  getAuthorsComponentsRelsMatches: (authorsText, rels) => {
   let [ authorsComponents, aaTexts ] = module.exports.getAuthorsComponentsFromText(authorsText);
    let matches = [];
    authorsComponents.forEach((authorComponents, i) => {
      let rel = rels.find(rel => rel.position === i+1);
      if (rel) {
        let person = rel.person;
        if (!person || !person.vinculations || person.vinculations.length === 0) {
          return;
        }
        let valid_vinculations = person.vinculations.filter(v => v.type !== "external_collaborator");
        if(person.has_vinculation === false || valid_vinculations.length === 0) {
          return;
        }
        let relNameComponents = [];
        relNameComponents.push(...unidecode(person.preferred_name.given_name.toLowerCase()).split(/ /))
        relNameComponents.push(...unidecode(person.preferred_name.family_name.toLowerCase()).split(/ /));
        let match = authorComponents.every(authorWord => {
          return relNameComponents.some(relWord => {
            return relWord.includes(authorWord);
          });
        });
        if (match) {
          matches.push({ slug: rel.person.slug, matched_text: aaTexts[i]});
        }
      }
    });

    return matches;
  }

};
